import { makeStyles } from "tss-react/mui"
import { Box, Stack, Typography } from "@mui/material"
import { faFileLines } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { StandardButton } from "../../../buttons/StandardButton"
import IMG from "./training.svg"

const useStyles = makeStyles()((theme) => ({
    container: {
        borderRadius: "1rem",
        background: theme.palette.common.white,
        border: "1px solid rgba(93, 93, 93, 0.1)",
        gridColumn: "span 2",
    },
    imgWrap: {
        width: "100%",
        height: "29.5rem",
    },
    img: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderTopLeftRadius: "1rem",
    },
    content: {
        flexGrow: "1",
        padding: "1.5rem",
    },
    title: {
        color: theme.palette.text.primary,
    },
    description: {
        color: theme.palette.tailwind.gray[500],
    },
    button: {
        background: "#1999D6",
        borderRadius: "2rem",
    },
}))

type HelpCardProps = Readonly<{
    title: string
    description: string
    handleCardClick: () => void
}>

export const TrainingGuideCard = ({ title, description, handleCardClick }: HelpCardProps) => {
    const { classes } = useStyles()

    return (
        <Stack alignItems="start" className={classes.container} onClick={handleCardClick}>
            <Box className={classes.imgWrap}>
                <img src={IMG} className={classes.img} />
            </Box>
            <Stack gap="1.5rem" className={classes.content}>
                <Stack gap=".75rem" flexGrow={1}>
                    <Typography variant="h6" className={classes.title}>
                        {title}
                    </Typography>
                    <Typography variant="body1" className={classes.description}>
                        {description}
                    </Typography>
                </Stack>
                <Box>
                    <LocalizedStrict id="help-dialog-training-guide-button">
                        <StandardButton
                            fullWidth={false}
                            color="blue"
                            startIcon={<FontAwesomeIcon icon={faFileLines} fontSize={24} />}
                            onClick={handleCardClick}
                            updateDefaultClasses={classes.button}
                        >
                            View Guide
                        </StandardButton>
                    </LocalizedStrict>
                </Box>
            </Stack>
        </Stack>
    )
}
